<div class="container">
  <form
    class="form"
    [formGroup]="reviewFormGroup"
    (ngSubmit)="emitSubmitEvent()">
    <label *ngIf="shouldDisplayTncCheckboxes" class="checkbox-container">
      <mat-checkbox [ngClass]="invalidFormClass()" formControlName="acceptTnc">
      </mat-checkbox>
      <span
        class="checkbox-label"
        [innerHtml]="
          'redeem_cash_v2.review.accept_tnc'
            | translate: termsTranslationParams()
        ">
      </span>
    </label>

    <span *ngIf="showErrorMessage()" class="error-message">
      {{ 'redeem_cash_v2.review.please_agree_to_tnc' | translate }}
    </span>

    <div class="submit-button-wrapper">
      <rd-shared-button
        [dataTestid]="'rc-review-form-button-redeem-now'"
        [buttonClass]="'submit-button'"
        [buttonContent]="buttonContent"
        [buttonTheme]="'primary'"
        [buttonType]="'submit'"
        [isDisabled]="cashRedemptionLoading || promocodeLoading">
        <ng-template #buttonContent>
          <span
            class="loading-text"
            *ngIf="
              cashRedemptionLoading || promocodeLoading;
              else cashRedemptionLoaded
            ">
            {{ 'redeem_cash_v2.review.loading' | translate }}
          </span>
          <ng-template #cashRedemptionLoaded>
            <span class="non-loading-text">{{
              'redeem_cash_v2.review.submit_button_text' | translate
            }}</span>
          </ng-template>
        </ng-template>
      </rd-shared-button>
    </div>
  </form>
</div>
